import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, IonSpinner, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { AuthProvider, useAuth } from './application/use-cases/auth/AuthContext';
import { RepositoryProvider } from './infrastructure/http/RepositoryProvider';
import PrivateRoute from './presentation/components/PrivateRoute';
import Login from './presentation/pages/Login';
import ForgotPassword from './presentation/pages/ForgotPassword';
import ResetPassword from './presentation/pages/ResetPassword';
import JoinDevice from './presentation/pages/JoinDevice';
import MainTabs from './presentation/pages/MainTabs';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/desktop.css';
import './theme/wow.css';

/* Leaflet (mapa de sitios/dispositivos) */
import 'leaflet/dist/leaflet.css';

// En iPhone el botón de volver dice "Back" (en inglés) junto a la flecha:
// se deja solo la flecha, como en Android, y le queda más lugar al título.
setupIonicReact({ backButtonText: '' });

const AppRoutes: React.FC = () => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--domiot-bg)',
        }}
      >
        <IonSpinner color="primary" />
      </div>
    );
  }

  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/forgot-password">
          <ForgotPassword />
        </Route>
        <Route exact path="/reset-password">
          <ResetPassword />
        </Route>
        <Route exact path="/join">
          <JoinDevice />
        </Route>
        <PrivateRoute path="/app">
          <MainTabs />
        </PrivateRoute>
        <Route exact path="/">
          <Redirect to="/app" />
        </Route>
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

const App: React.FC = () => (
  <RepositoryProvider>
    <AuthProvider>
      <IonApp>
        <AppRoutes />
      </IonApp>
    </AuthProvider>
  </RepositoryProvider>
);

export default App;
